import Charts from "./Charts";
import LocationMap from "./LocationMap";

export default {
    init() {
        this.loaderTimeout = null;

        $(document).on("pjax:start", () => {
            const content = $("#app-content").attr("aria-busy", "true");
            clearTimeout(this.loaderTimeout);
            this.loaderTimeout = setTimeout(() => {
                content.addClass("is-loading");
                content.find(".app-loader").attr("aria-hidden", "false");
            }, 150);
        });

        $(document).on("pjax:end", () => {
            clearTimeout(this.loaderTimeout);
            $("#app-content")
                .removeClass("is-loading")
                .attr("aria-busy", "false")
                .find(".app-loader")
                .attr("aria-hidden", "true");
            Charts.render();
            $("html, body").scrollTop(0);
            $(".modal-backdrop").remove();
            $("body").removeClass("modal-open").removeAttr("style");
            LocationMap.init();
        });
    },
};
